// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__341DS","colBig":"styles_colBig__3YGqd","colSmall":"styles_colSmall__2zSNf"};